module.exports = __webpack_public_path__ + "41f3c2d0c0d781d16cc9ff827eee53e8.MP3";